<script setup lang="ts">
interface Content {
  title?: string
  extraWraperClass?: string
  description?: string[]
  descImage?: string | string[]
}

interface Props {
  content: Content
}

const props = withDefaults(defineProps<Props>(), {
  content: () => ({
    title: '业务介绍',
    description: [
      '我们致力于为客户提供高质量的产品和服务',
      '通过创新技术和专业团队，实现客户价值最大化',
      '持续改进，追求卓越，成为行业领先者'
    ],
    descImage: '/images/business-introduction.png',
    extraWraperClass: ''
  })
})
</script>

<template>
  <section :class="props.extraWraperClass"
    class="page-business-introduction-col relative w-full flex flex-col items-center  max-ml:py-2rem">
    <PageTitle :title="props.content.title" />
    <PageContentCenter class="flex flex-col items-center">
      <div class="text-center  max-ml:pt-1.5rem w-80%">
        <p class="text-[#616671] text-[0.9rem] mb-[1.13rem] leading-[1.5rem]  max-ml:text-left "
          v-for="desc in props.content.description">
          {{ desc }}</p>
      </div>
    </PageContentCenter>
    <Pic v-if="!Array.isArray(props.content.descImage)" :src="props.content.descImage"
      class="w-[80rem] self-center ml:mt-4rem max-ml:hidden"></Pic>
    <PageContentCenter class="flex justify-around  max-ml:hidden" v-else>
      <Pic v-for="item in props.content.descImage" :src="item" class="mt-2.6rem">
      </Pic>
    </PageContentCenter>
  </section>
</template>

<style lang="scss" scoped>
.page-business-introduction-col {
  position: relative;
}
</style>
